import Swiper from './Swiper';
import getType from './Carbon.Frontend/Resources/Private/Assets/Scripts/getType';
import doesInclude from './Carbon.Frontend/Resources/Private/Assets/Scripts/doesInclude';
import startWith from './Carbon.Frontend/Resources/Private/Assets/Scripts/startWith';
import camelCase from './Carbon.Frontend/Resources/Private/Assets/Scripts/camelCase';
import convertFromString from './Carbon.Frontend/Resources/Private/Assets/Scripts/convertFromString';
import { mergeSettings, writeNavigationButtons } from './Functions';
import type from './Type';

/*
    If you are using new modules/settings (e.g. AutoPlay)
    you need to add them in Swiper.js, otherwise they
    will simply not work.
    !!!!
*/

export default function () {
    let swipers = document.querySelectorAll('.swiper-container');

    for (let i = 0; i < swipers.length; i++) {
        let slider = swipers[i];
        let wrapper = slider.querySelector('.swiper-wrapper');
        let nummberOfSlides = wrapper ? wrapper.childElementCount : false;
        if (nummberOfSlides) {
            let settings = {
                initialized: false,
            };

            // Get the settings from CSS class
            let classList = slider.classList;
            for (let i = 0; i < classList.length; i++) {
                let className = classList[i];
                if (
                    doesInclude(className, '--') &&
                    startWith(className, 'swiper-')
                ) {
                    let split = className.replace('swiper-', '').split('--');
                    let key = camelCase(split.shift());

                    // Note:
                    // This check for "navigation" is needed because otherwise
                    // the function "convertFromString" converts the string into
                    // an OBJECT "Navigation" in Chrome (for some reason).
                    if (split[0] == 'navigation') {
                        settings[key] = split[0];
                    } else {
                        settings[key] = convertFromString(split[0]);
                    }
                }
            }

            if (!settings.type && settings['navigation']) {
                let buttons = writeNavigationButtons({ slider });
                settings['navigation'] = {
                    nextEl: buttons.next,
                    prevEl: buttons.prev,
                };
            }

            if (!settings.type && settings['pagination']) {
                settings['pagination'] = {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'bullets',
                };
            }

            if (settings['autoplay']) {
                settings['autoplay'] = {
                    delay: 6000,
                };
            }

            // Is the slider already initialized?
            if (settings.initialized) {
                // Get parameter from existing slider
                let params = slider.swiper.originalParams;
                // Destroy existing slider
                slider.swiper.destroy();
                // Re-build slider
                new Swiper(slider, params);
            } else {
                if (
                    settings.type &&
                    getType(type[settings.type]) === 'function'
                ) {
                    type[settings.type](slider, settings, nummberOfSlides);
                } else {
                    settings = mergeSettings({
                        settings: settings,
                        nummberOfSlides,
                    });
                    let sw = new Swiper(slider, settings);
                }
            }
        }
    }
}
